import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CommunicationsService } from 'src/app/modules/communications/communications.service';
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { UsersService } from 'src/app/modules/users/users.service';
import { ChooseRecipientDialogComponent } from 'src/app/shared/components/dialogs/choose-recipient-dialog/choose-recipient-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { User } from 'src/app/shared/models/user/user.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
var SendEmailDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SendEmailDialogComponent(dialogRef, data, confirmDialog, chooseRecipientsDialog, configService, cookieService, toastrService, translateService, communicationsService, usersService, companiesService, authService, helperService, apiService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.confirmDialog = confirmDialog;
        this.chooseRecipientsDialog = chooseRecipientsDialog;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.communicationsService = communicationsService;
        this.usersService = usersService;
        this.companiesService = companiesService;
        this.authService = authService;
        this.helperService = helperService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.loggedUser = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.customContactField = [];
        this.options = {};
        this.showBcc = false;
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        this.attachmentBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.attach'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'accent',
            spinnerColor: 'accent',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paperclip',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.previousValue = {};
        this.displayedDocs = [];
        this.selectedDocs = [];
        this.preSelectedDocs = [];
        this.isAdmin = false;
        this.isMaster = false;
        this.phonebook = [];
    }
    /**
     * Init component
     *
     */
    SendEmailDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser.setData(res); }));
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "admin"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "operator") {
            this.isAdmin = true;
        }
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "master"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "collaborator") {
            this.isMaster = true;
        }
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Set company
        this.companyId = this.cookieService.get("requestedCompany");
        // Get form initial values and init the form
        this.getDataAndInitForm();
        // Stop loading dialog
        setTimeout(function () {
            _this.dialogIsLoading = false;
        }, 500);
    };
    Object.defineProperty(SendEmailDialogComponent.prototype, "showInsertedDocs", {
        /**
         * Whether to show the "inserted docs" side area: callers opening the dialog only to send
         * pre-attached files (data.hideInsertedDocs = true) don't need it
         *
         * @since 3.0.0
         */
        get: function () {
            return !(this.data && this.data.hideInsertedDocs === true);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Preload data and then init form. If something
     * goes wrong just init the form
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.getDataAndInitForm = function () {
        var _this = this;
        if (this.data) {
            // Get available docs from insertedDocs, if present
            if (this.data.insertedDocs) {
                // Normalize docs
                this.data.insertedDocs.forEach(function (docType) {
                    var e_1, _a;
                    if (!docType.data || (docType.data && !docType.data.document)) {
                        return;
                    }
                    try {
                        for (var _b = tslib_1.__values(docType.data.document), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var doc = _c.value;
                            if (doc && !doc.path) {
                                return;
                            }
                            if (!_this.model.docs) {
                                _this.model = tslib_1.__assign({}, _this.model, { docs: [] });
                            }
                            // Check if doc was pre-selected on dialog open
                            var newDoc = {};
                            if (_this.data.selectedDocs
                                && _this.data.selectedDocs.length
                                && _this.data.selectedDocs.map(function (el) { return el.toString(); }).includes(docType.docId.toString())) {
                                newDoc = {
                                    key: doc._id,
                                    value: docType.title + " - " + doc.originalName,
                                    path: doc.path
                                };
                                _this.model.docs.push(newDoc);
                                // newDoc = {
                                //   key: doc._id,
                                //   value: `${docType.title} - ${doc.originalName}`,
                                //   path: doc.path,
                                //   selected: true,
                                // };
                                // this.preSelectedDocs.push(newDoc);
                            }
                            // else {
                            //   newDoc = {
                            //     key: doc._id,
                            //     value: `${docType.title}`,
                            //     path: doc.path
                            //   };
                            // }
                            // this.model.docs.push(newDoc);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
            }
        }
        // Pre-attached files (already uploaded through FileService), e.g. a generated document:
        // they become the initial value of the "attachments" file-uploader field
        if (this.data && Array.isArray(this.data.attachments) && this.data.attachments.length) {
            this.model = tslib_1.__assign({}, this.model, { attachments: this.data.attachments });
        }
        // Get available recipients from phonebook
        if (this.isAdmin) {
            this.subscriptions.push(this.companiesService.getPhonebookListAdmin(0, null, null, "asc").subscribe(function (res) {
                if (res.status) {
                    _this.phonebook = res.data.items;
                    _this.initForm();
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (this.isMaster) {
            this.subscriptions.push(this.companiesService.getPhonebookList(this.companyId, 0, null, null, "asc").subscribe(function (res) {
                if (res.status) {
                    // show address associate to property
                    if (Array.isArray(res.data.items)) {
                        _this.phonebook = res.data.items;
                        // this.phonebook = res.data.items.filter((item: any) => {
                        //   return typeof item.propertyId !== 'undefined' && item.propertyId !== null && typeof item.propertyId._id !== 'undefined' && item.propertyId._id.toString() === this.data.propertyId.toString();
                        // });
                    }
                    _this.initForm();
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.initForm = function () {
        var _this = this;
        // Minimum char amount to activate search filtering
        var minTermLength = 1;
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        key: 'sender',
                        hide: true,
                        templateOptions: {
                            value: this.loggedUser.get("email"),
                        },
                    },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipients',
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipients'),
                            required: true,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipients;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipients'); },
                        },
                    },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipientsCc',
                        // hideExpression: (model): boolean => !model.showCc,
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipientsCc'),
                            required: false,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsCc;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipientsCc'); },
                        },
                    },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipientsBcc',
                        // hideExpression: (model): boolean => !model.showBcc,
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipientsBcc'),
                            required: false,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsBcc;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipientsBcc'); },
                        },
                    },
                    {
                        className: 'col-12 mb-0',
                        template: '<hr>',
                    },
                    {
                        className: 'col-12 pt-2 mb-1',
                        type: 'input',
                        key: 'subject',
                        templateOptions: {
                            label: this.translateService.instant('communications.fields.subject'),
                            placeholder: this.translateService.instant('communications.fields.subject'),
                            required: false,
                            minLength: 1,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'body',
                        defaultValue: this.data.body ? this.data.body : "",
                        templateOptions: {
                            label: this.translateService.instant('communications.fields.body'),
                            placeholder: this.translateService.instant('communications.fields.body'),
                            required: true,
                            maxLength: 5000,
                            rows: 6,
                        },
                    },
                    {
                        className: "col-12 col-md-6 mb-0",
                        type: "file-uploader",
                        key: "attachments",
                        templateOptions: {
                            required: false,
                            allowedFilesNumber: 999999,
                            allowedMBNumber: 100,
                            customLabel: this.translateService.instant('communications.fields.otherFiles'),
                        }
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.onClose = function (data) {
        var _this = this;
        // Prevent unsaved data loss
        if (this.form.dirty && !this.form.pristine) {
            var confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('common.warnings.warning'),
                    message: this.translateService.instant('common.warnings.unsavedData'),
                    btnOkText: this.translateService.instant('common.cta.continue'),
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                },
                disableClose: true,
            });
            // Subscribe to dialog result (only for 1 emit thanks to "take()")
            confirmDialogRef.beforeClosed()
                .pipe(take(1))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                _this.dialogRef.close();
                return;
            });
        }
        else {
            this.dialogRef.close();
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // One message at a time: «Invia» is off from the click to the answer of the back-end, so a
        // second click can neither open a second confirmation nor send the message twice
        if (this.formBtnOptions.active || this.formBtnOptions.disabled) {
            return;
        }
        // Prevent submit with no recipients
        // const customContactValue = (document.getElementById("customContactField") as HTMLInputElement).value;
        // if (!customContactValue && !this.selectedRecipients.length) {
        //   this.toastrService.warning(this.translateService.instant('common.warnings.no_recipient_selected'));
        //   return;
        // }
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        this.formBtnOptions.disabled = true;
        // Set recipients in model
        // this.model = {
        //   ...this.model,
        //   recipients: this.selectedRecipients.map((obj: any) => obj.email),
        // };
        var confirmDialogRef;
        // Email subject is not mandatory, but if it's empty we open a confirm dialog
        // to inform user that there's no subject in mail
        if (!this.form.controls['subject'].value) {
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('dialogs.confirm.title'),
                    message: this.translateService.instant('communications.add.noSubjectDialog.message'),
                    btnOkText: this.translateService.instant('communications.add.noSubjectDialog.confirm'),
                    btnOkIcon: 'fa-paper-plane',
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                    btnCancelIcon: 'fa-times-circle',
                }
            });
        }
        else {
            // Open confirm dialog before sending email
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('dialogs.confirm.title'),
                    message: this.translateService.instant('communications.add.confirmMessage'),
                    btnOkText: this.translateService.instant('common.cta.send'),
                    btnOkIcon: 'fa-paper-plane',
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                    btnCancelIcon: 'fa-times-circle',
                }
            });
        }
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        confirmDialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // Back to main dialog
                _this.formBtnOptions.disabled = false;
                return;
            }
            // User confirmed, can send mails
            _this.dialogIsLoading = true;
            _this.formBtnOptions.active = true;
            _this.createCommunication();
        });
    };
    /**
     * Create a new communication and send it
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.createCommunication = function () {
        var _this = this;
        // If message has no subject, let's put a default one before sending
        if (this.model && !this.model.subject) {
            this.model.subject = this.translateService.instant('communications.add.defaultSubject');
        }
        // Handle body formatting (add selectedDocs links). Built on a copy: the text in the dialog stays
        // as typed, so a retry after a failure sends the list once
        var body = this.model.body.concat("<ul>");
        // No inserted docs when the dialog is opened with attachments only
        (this.model.docs || []).forEach(function (doc) {
            if (!doc.path) {
                // This would never happen
                _this.toastrService.error('common.errors.unknown');
                return;
            }
            var name = doc.value;
            var path = doc.path.replace(/src[\\\/]assets/g, 'public');
            var url = "";
            if (path.substring(0, 22) === "https://app.archedi.it") {
                // url = path;
                var docFilename = path.substr(path.lastIndexOf("/"));
                url = _this.configService.apiHost + "/uploads/properties/" + _this.data.propertyId + "/documents" + docFilename;
            }
            else if (/^https?:\/\//i.test(path)) {
                // Already a complete address: prefixing the API host would double it
                url = path;
            }
            else {
                url = _this.configService.apiHost + "/" + path.replace(/^\/+/, '');
            }
            // Names and addresses are stored data: escaped, so that a "&" or a "<" cannot break the list
            var safeName = _this.escapeHtml(name);
            var safeUrl = _this.escapeHtml(url);
            body = body.concat("<li>" + safeName + ": <a href=\"" + safeUrl + "\">" + safeUrl + "</a></li><br>");
        });
        body = body.concat("</ul>");
        // Take only emails from recipients
        // let recipients = this.selectedRecipients.map(recipient => recipient.email);
        // Check if we have other addresses
        // const customContactValue = (document.getElementById("customContactField") as HTMLInputElement).value;
        // const otherContacts = customContactValue.split(";").map(el => el.trim());
        // Merge recipients
        // if (otherContacts[0] !== "") {
        //   recipients = [...recipients, ...otherContacts];
        // }
        var newCommunication = {
            recipients: this.model.recipients,
            recipientsCc: null,
            recipientsBcc: null,
            attachments: this.model.attachments,
            subject: this.model.subject,
            body: body,
            sendDocs: true,
            companyData: this.data.companyData,
            propertyName: this.data.propertyName,
            sentFromSupplierPage: this.data.sentFromSupplierPage,
        };
        if (Array.isArray(this.model.recipientsCc) && this.model.recipientsCc.length > 0) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsCc: this.model.recipientsCc });
        }
        else {
            delete newCommunication.recipientsCc;
        }
        if (Array.isArray(this.model.recipientsBcc) && this.model.recipientsBcc.length > 0) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsBcc: this.model.recipientsBcc });
        }
        else {
            delete newCommunication.recipientsBcc;
        }
        this.subscriptions.push(this.communicationsService.create(newCommunication)
            .pipe(finalize(function () {
            _this.formBtnOptions.active = false;
            _this.formBtnOptions.disabled = false;
            _this.dialogIsLoading = false;
        }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.communicationsService.onCommunicationCreated();
                _this.dialogRef.close();
                return;
            }
            _this.toastrService.error(_this.translateService.instant('common.errors.unknown'));
        }, function (err) {
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Escape a value written into the HTML of the message (a document name or a link)
     *
     * @since 3.0.0
     */
    SendEmailDialogComponent.prototype.escapeHtml = function (value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };
    /**
     * Update docs array with incoming element
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.onDocSelected = function (doc, checked) {
        if (doc && checked) {
            this.selectedDocs.push(doc);
        }
        else if (doc && !checked) {
            var index = this.selectedDocs.map(function (el) { return el.key; }).indexOf(doc.key);
            this.selectedDocs.splice(index, 1);
        }
    };
    /**
     * Update recipients basing on radio buttons changes
     *
     * @since 1.0.0
     */
    SendEmailDialogComponent.prototype.onChooseRecipientDialogOpen = function (key) {
        var _this = this;
        if (!key
            || (!this.phonebook)
            || (!this.phonebook.length)) {
            this.toastrService.error(this.translateService.instant('common.words.display_no_data'));
            return;
        }
        // Open dialog
        var dialogRef = this.chooseRecipientsDialog.open(ChooseRecipientDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                phonebook: this.phonebook,
                model: this.model[key],
            },
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            var _a;
            if (res) {
                var phonebookEmails_1 = _this.phonebook.map(function (contact) { return contact.email; });
                var customInsertedEmails = _this.model[key]
                    ? _this.model[key].filter(function (email) { return !phonebookEmails_1.includes(email); })
                    : [];
                var newData = tslib_1.__spread(res, customInsertedEmails);
                _this.model = tslib_1.__assign({}, _this.model, (_a = {}, _a[key] = newData, _a));
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    return SendEmailDialogComponent;
}());
export { SendEmailDialogComponent };
